import { createService } from "./serviceFactory";

export const logoutService = createService("logout");
